<template>
<div class="abnomalRecord">
  <el-drawer title="异常启用" size="500px" :visible.sync="drawerShow" @close="closeMess" direction="rtl" ref="drawer">
    <div class="drawerWrap">
      <div class="drawerBody">
        <el-form ref="form" :model="form" :rules="formRules" label-position="right" label-width="120px">
          <el-form-item label="异常类型" prop="repairType">
            <el-select v-model="form.repairType" placeholder="异常类型" clearable>
            <el-option v-for="item in repairTypeOptions" :key="item.dictCode" :label="item.dictValue" :value="item.dictCode"></el-option>
          </el-select>
          </el-form-item>
          <el-form-item label="异常说明" prop="repairContent">
            <el-input type="textarea" v-model="form.repairContent" placeholder="请输入异常说明" maxlength="80"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="drawerFoot">
        <el-button type="primary" @click="confirmHandle()" :loading="loading">{{ loading ? '提交中' : '提交' }}</el-button>
        <el-button @click="closeMess()">取 消</el-button>
      </div>
    </div>
  </el-drawer>
  <div class="mainContent" :style="styleObject">
    <div class="container">
      <div class="query newDate">
        <span>
          <el-date-picker v-model="creatTime" type="datetimerange" :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right">
          </el-date-picker>
          <el-input placeholder="设备名称" v-model="search.deviceName" style="width:170px;" clearable></el-input>
          <el-input placeholder="安装位置" v-model="search.installLocaltion" style="width:220px;" clearable></el-input>
          <!-- <el-date-picker
            v-model="search.repairTime"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="异常时间">
          </el-date-picker> -->
          <!-- <el-select v-model="search.repairType" placeholder="异常类型" clearable>
            <el-option v-for="item in repairTypeOptions" :key="item.dictCode" :label="item.dictValue" :value="item.dictCode"></el-option>
          </el-select> -->
          <button class="primaryBtn" @click="serachData">搜索</button>
        </span>
        <button class="primaryBtn" @click="dealDialog"><span style="color:#fff">启用</span></button>
        <p class="tips">
          <span>说明：以下设备当天报警5次以上被监控为异常设备</span>
          <span>（点击启用恢复设备正常报警功能，并重新开始计数）</span>
        </p>
      </div>

      <border-table :tableData="dataList" :pageSizes="[10, 20, 50]" :pages="pagination" :loading="tableLoading" :current-page="pagination.page" @currentChange="alarmCurrentChange" @sizeChange="alarmSizeChange" @selectionChange="handleSelectionChange">
        <el-table-column type="selection" width="50" border></el-table-column>
        <el-table-column prop="name" label="设备名称" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="deviceId" label="设备ID" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="imei" label="设备IMEI" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="installLocaltion" label="安装信息" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="num" label="报警总数" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="updateTime" label="更新时间" :show-overflow-tooltip="true"></el-table-column>
        <!-- <el-table-column prop="" label="操作" fixed="right" width="200px">
            <template slot-scope="scope">
               <el-button type="text" icon="el-icon-s-claim" @click="dealDialog(scope.row)">启用</el-button>
            </template>
        </el-table-column> -->
      </border-table>
    </div>
  </div>
</div>
</template>

<script>
import BorderTable from "@/components/common/BorderTable";
import HandleFault from "@/components/faultHository/HandleFault";
import { formatTime } from "@/utils/validate";
export default {
  components: {
    BorderTable,
    HandleFault
  },
  data() {
    return {
      treeData: [],
      currentTreeId: 0,
      treeHandler: false,
      fbdate: null,
      fedate: null,
      creatTime: [],
      search: {
        deviceName: '',
        installLocaltion: ''
      },
      repairTypeOptions: [
        { dictValue: "灰尘", dictCode: 15 },
        { dictValue: "低电量", dictCode: 16 },
        { dictValue: "维修", dictCode: 20 },
        { dictValue: "维保", dictCode: 30 },
        { dictValue: "检测", dictCode: 40 },
        { dictValue: "其他", dictCode: 99 }
      ],
      styleObject: {
        height: ""
      },
      tableLoading: false,
      dataList: [],
      pagination: {
        show: true,
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      drawerShow: false,
      handleState: '',
      params: {},
      paramdata: '',
      content: '',
      handleType: '',
      loading: false,
      creatTime: [],
      pickerOptions: {
        shortcuts: [{
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      form: {
        deviceId: '',
        id: '',
        repairType: '',
        repairContent: ''
      },
      formRules: {
        repairType: [{ required: true, message: "异常类型不能为空", trigger: "blur" }],
        repairContent: [{ required: true, message: "异常说明不能为空", trigger: "blur" }],
      },
      deviceIds: ''
    };
  },
  created() {
    const start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
    this.creatTime[0] = start
    this.creatTime[1] = new Date();

    this.makeheight();
    this.reloaTable();
  },
  methods: {
    serachData() {
      //查询//搜索
      this.pagination.currentPage = 1;
      this.reloaTable();
    },
    //表格当前页变化时
    alarmCurrentChange(val) {
      this.pagination.currentPage = val;
      this.reloaTable();
    },
    //表格展示条数变化时
    alarmSizeChange(val) {
      this.pagination.pageSize = val;
      this.pagination.currentPage = 1;
      this.reloaTable();
    },
    handleSelectionChange(val) {
      if (val.length) {
        let temp = val.map(({ deviceId }) => deviceId)
        this.deviceIds = temp.join()
      }
    },
    /**
     * @Description 请求列表
     * @Author      YOYO     -             2022-11-22
     */
    reloaTable() {
      let startTime, endTime;
      if (this.creatTime.length >= 2) {
        startTime = formatTime(this.creatTime[0])
        endTime = formatTime(this.creatTime[1])
      }
      console.log(startTime, endTime)
      let { deviceName, installLocaltion } = this.search
      let { currentPage, pageSize } = this.pagination
      let params = {
        deviceName,
        installLocaltion,
        pageSize,
        page: currentPage,
        startTime,
        endTime
      }
      this.tableLoading = true

      this.request.post('/front/faultyDevice/query', params).then(res => {
        this.tableLoading = false
        if (res.code == 200) {
          this.dataList = res.data.data
          this.pagination.total = res.data.totalCount
        } else if (res.code == 500) {
          this.dataList = []
          this.msg.warn(res.msg);
        }
      }).catch(error => {
        console.log(error)
      })
    },
    //关闭抽屉
    closeMess() {
      this.loading = false;
    },
    formatDate(d) {
      let month = d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
      let day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
      let hours = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
      let min = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
      let sec = d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
      let times = d.getFullYear() + "-" + month + "-" + day+" "+hours+":"+min+":"+sec;
      return times;
    },
    formatterDate(date) {
      let result = new Date(date);
      return result;
    },
    //动态获取中间滚动高度,'height'为头部和尾部的高度之和
    makeheight(height = 116) {
      let _this = this;
      _this.styleObject.height = window.innerHeight - height + "px";
      window.onresize = () => {
        return (() => {
          _this.styleObject.height = window.innerHeight - height + "px";
        })();
      };
    },
    dealDialog() {
      if (!this.deviceIds) return this.msg.warn('请先勾选设备数据！')

      this.$confirm('此操作将启用选中的设备, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.request.post(`/front/faultyDevice/enableDevices?deviceIds=${this.deviceIds}`).then(res => {
          if (res.code == 200) {
            this.deviceIds = ''
            this.reloaTable()
            this.msg.success('启用成功')
          } else if (res.code == 500) {
            this.msg.warn(res.msg);
          }
        })
      }).catch(() => {
        this.msg.info('已取消导出')
      });
    },
    // 异常保存
    confirmHandle () {
      this.$refs["form"].validate(valid => {
        console.log(this.form)
        if (!valid) {
          return this.msg.error("请按要求完善表单信息");
        }
        let params = {
          ...this.form
        }
        this.loading = true
        this.request.post("/front/device/repair/update", params).then(rs => {
          this.loading = false
          if (rs.code === 200) {
            this.drawerShow = false
            this.msg.success('启用成功')
            this.reloaTable();
          } else if (rs.code == 500) {
            this.msg.warn(rs.msg);
          }
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.abnomalRecord {
  position: relative;

  .topTabs {
    height: 40px;
    background: #fff;
  }

  .mainContent {
    margin: 12px;
    padding: 15px 20px;
    background: #fff;
    box-sizing: border-box;
    overflow: auto;

    .container {
      // padding-left: 260px;
    }

    // .radio{
    //    margin: 20px 0;
    // }
    .query {
      margin-bottom: 20px;
    }

    .edit {
      background: #327ae6;
      color: #fff;
    }

    .del {
      background: #eaa13a;
      color: #fff;
    }

    // .btnS{
    //    color: #2A7EE1;
    //    border:1px solid #A1C6F3;
    //    background: #EFF3FC;
    //    margin-right:24px;
    //    &:hover{

    //    }
    // }
  }
  .primaryBtn {
    margin-top: 10px;
  }
  .tips {
    display: inline-block;
    color: #999;
    vertical-align: middle;
    span {
      display: block;
      font-size: 12px;
    }
  }
}
</style><style lang="scss">
.abnomalRecord {
  .treeAside {
    position: absolute;
    width: 300px;
    height: 100%;
    padding: 15px 20px;
    left: 0;
    top: 0;
    box-sizing: border-box;

    .treeTop {
      position: absolute;
      height: 40px;
      line-height: 40px;
      font-size: 0;
      font-weight: bold;
      top: 20px;
      z-index: 10;
      // left: 30px;
      padding-left: 10px;

      .treeTopTitle {
        margin-right: 115px;
        // width: 500px;
        font-size: 18px;
        color: #333;
      }

      .el-button {
        margin-left: -24px;
      }

      .complete {
        margin-left: 10px;
      }
    }

    .treeBox {
      overflow: hidden;
      height: 100%;
      border: 1px solid #ebeef5;
      padding: 40px 0 10px;
      box-sizing: border-box;
    }

    .tree {
      height: 100%;
      overflow: auto;

      .el-tree-node__content {
        height: 40px;
      }

      .custom-tree-node {
        height: 40px;
        line-height: 40px;
        width: 100%;

        .treeLabel {
          font-size: 14px;
          display: inline-block;
          width: 130px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .treeBtn {
          float: right;

          .el-button {
            margin-left: 0;
          }
        }
      }
    }
  }

  .query {
    .el-input {
      // width: 380px;
      margin-right: 10px;

      .el-input__inner {
        line-height: 36px;
        height: 36px;
      }
    }

    .el-select {
      width: 180px;
      margin-right: 10px;

      .el-input {
        width: 180px;
        margin-right: 10px;

        .el-input__inner {
          line-height: 36px;
          height: 36px;
        }
      }
    }

    .el-range-editor.el-input__inner {
      height: 36px;
      line-height: 36px;
      padding: 5px 10px;
      margin-right: 10px;
    }
  }
  .newDate{
    .el-date-editor--datetimerange.el-input,.el-date-editor--datetimerange.el-input__inner{
      width: 380px;
    }
  }
}

.exportBtn {
  background: #2177E6;
  color: #fff;
  padding: 11px 15px;
  height: 36px;
  line-height: 36px;
  border: none;
  font-size: 14px;
  border-radius: 4px;
  outline: none;
  cursor: pointer;
  margin-right: 10px;
}
</style>
